import { Reveal, SectionHeading } from "@/components/motion";

const AUDIENCES = [
  "Delivery carriers and last-mile networks",
  "Dispatch platforms and TMS vendors",
  "Fleet management and telematics systems",
  "Insurance and compliance auditors",
  "Enterprise routing and fulfillment networks",
  "Fraud, risk, and liability teams",
];

const Audiences = () => (
  <section data-testid="audiences" className="border-b border-border">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <SectionHeading index="08" eyebrow="Who GeoVerify Is For" title="Built for teams that need proof." />
        <Reveal delay={0.15}>
          <p className="mt-6 text-base text-muted-foreground leading-relaxed max-w-md">
            GeoVerify sits above your routing and telemetry stack as a neutral truth engine —
            parcel, grocery, medical courier, field service, freight, and insurance.
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <div className="border-t border-border">
          {AUDIENCES.map((a, i) => (
            <Reveal key={a} delay={i * 0.05}>
              <div
                data-testid={`audience-${i}`}
                className="group flex items-baseline gap-6 border-b border-border py-6 hover:bg-foreground transition-colors duration-300 px-2 lg:px-6"
              >
                <span className="font-mono text-xs text-muted-foreground group-hover:text-background/60 transition-colors duration-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-display font-bold tracking-tight text-xl lg:text-2xl group-hover:text-background transition-colors duration-300">
                  {a}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Audiences;
